import { combineReducers } from 'redux';
import Dropdown from "./Dropdown.js";

const rootReducer = combineReducers({
  Dropdown
});

export default rootReducer;
